import { Inject, Injectable, TransferState } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {
  BehaviorSubject,
  catchError,
  finalize,
  Observable,
  of,
  tap,
} from 'rxjs';

import { ApiService } from './api.service';
import { ApiUrl } from './constants';
import { RequestParams } from '@src/app/shared/types/common';
import {
  GetAnnouncementResponse,
  GetBondReponse,
  GetContactResponse,
} from '@src/app/shared/types/api';
import { RoutesEnum } from '@src/app/enums';
import { Router } from '@angular/router';
import { HOMEPAGE_KEY } from '../transfer-state/keys';
import { SeoMetaService } from './seo-meta.service';

@Injectable({
  providedIn: 'root',
})
export class PromoLandingService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();

  constructor(
    @Inject(Router) private router: Router,
    private transferState: TransferState,
    private apiService: ApiService,
    private seoMetaService: SeoMetaService,
  ) {}

  get isLoading(): boolean {
    return this.isLoadingSubject.value;
  }

  setIsLoading(value: boolean): void {
    this.isLoadingSubject.next(value);
  }

  /**
   * @description Handling API call errors
   * @param {HttpErrorResponse} error
   */
  handleError(error: HttpErrorResponse): void {
    this.isLoadingSubject.next(false);

    if (
      error.error?.statusCode === 404 ||
      error.error?.status === 404 ||
      error?.status === 404
    ) {
      this.router.navigate(['/' + RoutesEnum.NOT_FOUND], {
        skipLocationChange: true,
      });
    } else if (error.error?.message) {
      console.error(error.error?.message);
    }
  }

  getPromoLandings(params: RequestParams): Observable<Record<string, any>> {
    return this.apiService.request({
      method: 'get',
      endpoint: ApiUrl.getPromoLandings,
      params,
    });
  }

  getPromoLandingBySlug(
    slug: number | string,
    params: RequestParams,
  ): Observable<Record<string, any>> {
    this.isLoadingSubject.next(true);

    return this.apiService.request({
      method: 'get',
      endpoint: ApiUrl.getPromoLandingBySlug(slug),
      params,
    });
  }

  postPromoLandingApplication(
    body: Record<string, any>,
    params?: any,
  ): Observable<Record<string, any>> {
    return this.apiService.request({
      method: 'post',
      endpoint: ApiUrl.postPromoLandingApplication,
      params,
      body,
    });
  }
}
